// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import i18n from './i18n'
import App from './App.vue'
import store from './store/'
import router from './router'
import mixins from './mixins'
import { VueAxios } from './utils/request'
import pagination from './views/webpublic/modules/pagination'

//water marker
import watermark from './core/directives/watermark'
import watermark_img from './core/directives/watermarker_img'
import bootstrap from './core/bootstrap'
import QueryBuilder from 'vue-query-builder'
import './core/lazy_use'
import './permission' // permission control
import './utils/filter' // global filter
import './components/global.less'
import { transformTime } from './components/_util/util'

Vue.prototype.transformTime = transformTime

Vue.directive('watermark', watermark)
Vue.directive('image-to-canvas', watermark_img)

Vue.use(pagination)
Vue.use(mixins)
Vue.use(VueAxios)
Vue.component('vPagination', pagination)
Vue.component('QueryBuilder', QueryBuilder)

Vue.config.productionTip = false
new Vue({
  store,
  router,
  i18n,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
